import React, { forwardRef } from 'react';
import { Stack, StackProps } from '@chakra-ui/react';

export type QStackProps = StackProps;

export const QStack = forwardRef<HTMLDivElement, QStackProps>((props, ref) => {
  return <Stack {...props} ref={ref} />;
});
QStack.displayName = 'QStack';
